'use strict'

// import Vue from 'vue'

import UserConfigModel from './UserConfigModel.js'

let UserConfigs = new UserConfigModel()

import getInstall from './js/getInstall.js'

const install = getInstall(UserConfigs, 'User')

const exportDefault = {
  UserConfigs,
  Configs : UserConfigs,
  install,
}

export {
  UserConfigs,
  UserConfigs as Configs,
  install
}
export default exportDefault
